import { Shield, Zap, Cloud, Sparkles } from 'lucide-react';
import { LocalizedAnchor } from './LocalizedLink';

const pillars = [
  {
    icon: Shield,
    title: 'EU-native',
    description: 'Data stays in the Netherlands. GDPR-first architecture with a published sub-processor list.',
  },
  {
    icon: Zap,
    title: 'ClickHouse-powered',
    description: 'Sub-200ms P95 search across billions of log events using the same engine that powers Cloudflare and Uber.',
  },
  {
    icon: Cloud,
    title: 'OpenTelemetry-first',
    description: 'Native OTLP ingest, Vector, Helm chart, and a HTTP API — no proprietary agents required.',
  },
  {
    icon: Sparkles,
    title: 'AI investigator built-in',
    description: 'Claude-powered investigations that turn a vague alert into a root-cause hypothesis in minutes.',
  },
] as const;

export function SocialProofSection() {
  return (
    <section className="py-24 sm:py-32 bg-gray-50 dark:bg-gray-950 border-y border-gray-200 dark:border-gray-800/60">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section header */}
        <div className="max-w-2xl mx-auto text-center mb-16 sm:mb-20 animate-on-scroll">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-50 dark:bg-primary-900/20 border border-primary-200 dark:border-primary-800/30 mb-4">
            <span className="text-xs font-medium text-primary-700 dark:text-primary-300">
              Early Access
            </span>
          </div>
          <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-gray-900 dark:text-white text-balance">
            Built for Platform Engineering teams
          </h2>
          <p className="mt-4 text-lg text-gray-600 dark:text-gray-400 text-balance">
            LogPulse is in Early Access. Instead of fake testimonials, here is exactly what we stand for.
          </p>
        </div>

        {/* Pillars grid */}
        <div
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 animate-on-scroll"
          data-animate="fade-up"
        >
          {pillars.map((pillar, i) => {
            const Icon = pillar.icon;
            return (
              <div
                key={pillar.title}
                className="rounded-2xl p-6 bg-white dark:bg-gray-900/60 border border-gray-200/80 dark:border-gray-700/50 shadow-md shadow-gray-200/50 dark:shadow-none backdrop-blur-md ring-1 ring-gray-100 dark:ring-transparent"
                style={{ transitionDelay: `${i * 100}ms` }}
              >
                <div className="w-10 h-10 rounded-lg flex items-center justify-center bg-primary-50 dark:bg-primary-500/10 mb-4">
                  <Icon className="h-5 w-5 text-primary-500" />
                </div>
                <div className="text-base font-semibold text-gray-900 dark:text-white">{pillar.title}</div>
                <div className="mt-2 text-sm text-gray-600 dark:text-gray-400 leading-relaxed">{pillar.description}</div>
              </div>
            );
          })}
        </div>

        {/* CTA link */}
        <div className="mt-12 text-center animate-on-scroll" data-animate="fade-up">
          <LocalizedAnchor
            href="/contact"
            className="text-sm font-medium text-primary-600 dark:text-primary-400 hover:text-primary-500 dark:hover:text-primary-300 transition-colors"
          >
            Become an Early Access design partner
            <span aria-hidden="true"> &rarr;</span>
          </LocalizedAnchor>
        </div>
      </div>
    </section>
  );
}
